import { makeStyles } from '@material-ui/core/styles'
import { theme } from 'config/constants/theme/theme'

export interface IProps {
  alignItems: string
  justifyContent: string
}

export default makeStyles<{}, IProps>(() => ({
  formContainer: {},
  paper: {
    boxShadow:
      '0px 0px 3px 1px rgba(0, 0, 0, 0.05), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)',
    margin: '15px 0',
    padding: 25,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: 10
    }
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: ({ alignItems }) => alignItems,
    justifyContent: ({ justifyContent }) => justifyContent
  },
  formTitle: {
    fontSize: 20,
    fontWeight: 300,
    textAlign: 'center',
    color: 'rgb(69, 18, 149)'
  }
}))
